var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-info-admin"},[_c('div',{staticClass:"user-info-admin__inner"},[_c('div',{staticClass:"user-info-admin__caption"},[_vm._v(" "+_vm._s(_vm.$t('express_Created.localization_value.value'))+" ")]),_c('div',{staticClass:"user-info-admin__large"},[_vm._v(" "+_vm._s(_vm._f("moment")(new Date(),"DD MMM, YYYY"))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }